<div [formGroup]="kouzaForm">
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>口座名義（漢字）</mat-label>
        <input matInput
          formControlName="kohuriActknj"
          autocomplete="off"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>口座名義（カナ）</mat-label>
        <input matInput
          formControlName="meigiKana"
          autocomplete="off"/>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>金融機関コード</mat-label>
        <input matInput
          formControlName="extBankfcCode"
          autocomplete="off"
          (blur)="searchBankNm()"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>支店コード</mat-label>
        <input matInput
          formControlName="extBranchCode"
          autocomplete="off"
          (blur)="searchBranchNm()"
        />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>金融機関名</mat-label>
        <input matInput
          formControlName="bankfcAname"
          class="font-color-display-only"
          readonly
        />
      </mat-form-field>
      <mat-form-field appearance="fill" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>支店名</mat-label>
        <input matInput
          formControlName="branchAname"
          class="font-color-display-only"
          readonly
        />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form-select" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>預金種別</mat-label>
        <mat-select
          formControlName="dptClsfy">
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of codeDptClsfyCdList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>口座番号</mat-label>
        <input matInput
          formControlName="kouzaNo"
          autocomplete="off"/>
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="100">
        <mat-label>受取方法区分</mat-label>
        <mat-select
          formControlName="recivWayDivcd">
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of codeRecivMethodList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>